import styled from 'styled-components';

// Styled container that takes full width and height of parent
export const Container = (styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
